module.exports = __webpack_public_path__ + "fonts/TikTokDisplayMedium.537eeb5c.otf";